import { history } from '../routers/AppRouter';
import axios from 'axios';
import paths from '../helpers/paths';
import { getToken } from '../helpers/auth';
import { setProductDetails, setProductMessageResponse, 
         setSingleProductCategory } from '../helpers/product';
import { setHoverState,} from '../actions/css';
import { setWaitingState, setModalState } from '../actions/css';

// const createProductUrl = 'http://localhost:3000/api/v1/product/newproduct';
// const getProducts = 'http://localhost:3000/api/v1/product/products';
// const getSingleProduct = 'http://localhost:3000/api/v1/product';

const createProductUrl = 'https://coozallbackend.herokuapp.com/api/v1/product/newproduct';
const getProducts = 'https://coozallbackend.herokuapp.com/api/v1/product/products';
const getSingleProduct = 'https://coozallbackend.herokuapp.com/api/v1/product';


export const setCreateProductImages = (fileContent1) => (
  {
    type:'SET_CREATE_PRODUCT_IMAGES',
    fileContent1,
  }
);


export const setCallBackMessage = (responseMessage) => (
  {
    type: 'SET_CALLBACK_MESSAGE',
    responseMessage,
  }
);

export const setProductsMessage = (productsMessage) => (
  {
    type: 'SET_PRODUCTS_MESSAGE',
    productsMessage,
  }
);

export const setProducts = (products) => (
  {
    type: 'SET_PRODUCTS',
    products,
  }
);

export const setSingleProduct = (singleProduct) => (
  {
    type: 'SET_SINGLE_PRODUCT',
    singleProduct,
  }
);

export const setProductModalState = (productModal) => (
  {
    type: 'SET_PRODUCT_MODAL_STATE',
    productModal,
  }
);

export const setSingleProductForCart = (productForCart) => (
  {
    type: 'SET_SINGLE_PRODUCT_FOR_CART',
    productForCart,
  }
)


export const createProduct = (productFile, productName, price, discountPrice, 
  quantity, description, category, subCategory, level, state, city) => dispatch => {
  dispatch(setCallBackMessage('Creating Order...'))
  let formData = new FormData();
  for(let i=0; i<productFile.length; i++){
    formData.append('imgfiles', productFile[i]);
  }
  formData.append('name', productName);
  formData.append('price', price);
  formData.append('description', description);
  formData.append('quantity', quantity);
  formData.append('discountPrice', discountPrice),
  formData.append('level', level);
  formData.append('category', category);
  formData.append('subCategory', subCategory);
  formData.append('state', state);
  formData.append('city', city);
  return axios({
    method: 'post',
    url: `${createProductUrl}`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getToken()}`
    },
    data: formData
  })
  .then(({data}) => {
    if( 200 <= data.status < 400){
      dispatch(setCallBackMessage(data.data));
    }else{
      dispatch(setCallBackMessage(data.error));
    };
  }).catch(error => {
    dispatch(setCallBackMessage(error.response.data.error));
  });
};

export const getAllProducts = (category) => dispatch => {
  dispatch(setWaitingState(true))
  return axios.get(`${getProducts}?category=${category}`)
    .then((response) => {
      dispatch(setProductsMessage(response.data.message));
      dispatch(setProducts(response.data.data));
      dispatch(setSingleProduct(category));

      setProductDetails(response.data.data)
      setProductMessageResponse(response.data.message);
      setSingleProductCategory(category);
      history.push(paths.search);
      dispatch(setHoverState(false));
      dispatch(setWaitingState(false))
      dispatch(setModalState(false))
    })
    .catch((error) => {
      dispatch(setWaitingState(false))
      dispatch(setModalState(false))
      dispatch(setHoverState(false));
      dispatch(setProductsMessage(error.response.data.error));   
      history.push(paths.search);
    });
 };


 export const getSingleProductForCart = (productid) => dispatch => {
  dispatch(setWaitingState(true))
  return axios.get(`${getSingleProduct}/${productid}`)
    .then((response) => {
      dispatch(setSingleProductForCart(response.data.data));
      history.push(paths.search);
      dispatch(setHoverState(false));
      dispatch(setWaitingState(false))
      dispatch(setModalState(false))
      dispatch(setProductModalState(true));
    })
    .catch((error) => {
      dispatch(setWaitingState(false))
      dispatch(setModalState(false))
      dispatch(setHoverState(false));  
      history.push(paths.search);
    });
 };

 export const unMountProduct = () => {
  dispatch(setProducts([]));
 };





